import styled from "@emotion/styled";

export const Right = styled.div`
    width: 100%;
    text-align: right;
`;
